import React, { useState } from "react";
import { useMutation } from "@apollo/react-hooks";
import { RESEND_VERIFICATION_EMAIL } from "../../graphql/mutations";

const EmailVerification = () => {
  //state
  const [message, setMessage] = useState("");

  //queries
  const [receiveEmail, { loading }] = useMutation(RESEND_VERIFICATION_EMAIL, {
    onCompleted: (data: any) => handleConfirm(data),
  });
  const handleConfirm = async (data: any): Promise<void> => {
    if (
      data.UserOps.resendVerification &&
      !data.UserOps.resendVerification.error
    ) {
      setMessage("success");
    } else {
      setMessage("error");
    }
  };

  return (
    <>
      <p className="h5 mb-3 mt-1 text-center">Email verification</p>
      {!message ? (
        <p className="m-0" style={{ lineHeight: "20px" }}>
          We just sent you an email to confirm your email address. Please click
          the confirmation link in the email to activate your account and get
          started. Didn't receive the email?
          <p className="mt-2 mb-0" style={{ lineHeight: "20px" }}>
            Please check your spam folder or{" "}
            <span
              className="cursor-pointer click-here"
              onClick={() => !loading && receiveEmail()}
            >
              click here
            </span>{" "}
            to resend the confirmation email.
          </p>
        </p>
      ) : (
        <>
          {message === "error" ? (
            <p className="text-danger">Verification Failed !</p>
          ) : (
            <div>
              <p className="mb-2 text-success">
                Verification email successfully sent!{" "}
              </p>
              Please check the last verification email received for your account
              confirmation link.
            </div>
          )}
        </>
      )}
    </>
  );
};

export default EmailVerification;
